import type { ReactNode } from "react";

/** Icônes au trait, portées du mockup (icons.jsx). */

export interface IconProps {
  size?: number;
  sw?: number;
  fill?: string;
}

function S({ children, size = 24, sw = 1.8, fill = "none" }: IconProps & { children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke="currentColor"
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  );
}

export const Icons = {
  Gear: (p: IconProps) => (
    <S {...p}>
      <circle cx="12" cy="12" r="3.1" />
      <path d="M19.4 13a1.65 1.65 0 0 0 .33 1.82l.05.05a1.9 1.9 0 1 1-2.69 2.69l-.05-.05a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a1.9 1.9 0 0 1-3.8 0v-.09a1.65 1.65 0 0 0-1.08-1.51 1.65 1.65 0 0 0-1.82.33l-.05.05a1.9 1.9 0 1 1-2.69-2.69l.05-.05a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a1.9 1.9 0 0 1 0-3.8h.09a1.65 1.65 0 0 0 1.51-1.08 1.65 1.65 0 0 0-.33-1.82l-.05-.05a1.9 1.9 0 1 1 2.69-2.69l.05.05a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a1.9 1.9 0 0 1 3.8 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.05-.05a1.9 1.9 0 1 1 2.69 2.69l-.05.05a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a1.9 1.9 0 0 1 0 3.8h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </S>
  ),
  List: (p: IconProps) => (
    <S {...p}>
      <path d="M8 6h12M8 12h12M8 18h12" />
      <circle cx="3.5" cy="6" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="3.5" cy="12" r="1.1" fill="currentColor" stroke="none" />
      <circle cx="3.5" cy="18" r="1.1" fill="currentColor" stroke="none" />
    </S>
  ),
  Mic: (p: IconProps) => (
    <S {...p}>
      <rect x="9" y="2.5" width="6" height="11" rx="3" />
      <path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M8.5 21h7" />
    </S>
  ),
  Pen: (p: IconProps) => (
    <S {...p}>
      <path d="M14.5 4.5l5 5M3 21l1.2-4.2L16 5l3 3L7.2 19.8 3 21z" />
    </S>
  ),
  Photo: (p: IconProps) => (
    <S {...p}>
      <rect x="3" y="4.5" width="18" height="15" rx="2.5" />
      <circle cx="8.5" cy="10" r="1.7" />
      <path d="M3 16.5l4.5-4 3.5 3 4-4.5 6 6.5" />
    </S>
  ),
  Plus: (p: IconProps) => (
    <S {...p}>
      <path d="M12 5v14M5 12h14" />
    </S>
  ),
  Play: (p: IconProps) => (
    <S {...p} fill="currentColor">
      <path d="M7 5.5v13l11-6.5z" stroke="none" />
    </S>
  ),
  Pause: (p: IconProps) => (
    <S {...p} fill="currentColor">
      <rect x="6.5" y="5" width="4" height="14" rx="1.2" stroke="none" />
      <rect x="13.5" y="5" width="4" height="14" rx="1.2" stroke="none" />
    </S>
  ),
  Stop: (p: IconProps) => (
    <S {...p} fill="currentColor">
      <rect x="6.5" y="6.5" width="11" height="11" rx="2.5" stroke="none" />
    </S>
  ),
  Back: (p: IconProps) => (
    <S {...p}>
      <path d="M15 5l-7 7 7 7" />
    </S>
  ),
  Check: (p: IconProps) => (
    <S {...p}>
      <path d="M5 12.5l4.5 4.5L19 6.5" />
    </S>
  ),
  Close: (p: IconProps) => (
    <S {...p}>
      <path d="M6 6l12 12M18 6L6 18" />
    </S>
  ),
  Trash: (p: IconProps) => (
    <S {...p}>
      <path d="M4 7h16M9 7V4.5h6V7M6 7l1 13h10l1-13" />
    </S>
  ),
  Cloud: (p: IconProps) => (
    <S {...p}>
      <path d="M7 18a4 4 0 0 1-.5-7.97A5.5 5.5 0 0 1 17 9.5a3.8 3.8 0 0 1 .3 7.5H7z" />
    </S>
  ),
  CloudCheck: (p: IconProps) => (
    <S {...p}>
      <path d="M7 18a4 4 0 0 1-.5-7.97A5.5 5.5 0 0 1 17 9.5a3.8 3.8 0 0 1 .3 7.5" />
      <path d="M9.5 15.5l1.8 1.8L15 13.6" />
    </S>
  ),
  Sun: (p: IconProps) => (
    <S {...p}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.5 4.5l1.8 1.8M17.7 17.7l1.8 1.8M4.5 19.5l1.8-1.8M17.7 6.3l1.8-1.8" />
    </S>
  ),
  Moon: (p: IconProps) => (
    <S {...p}>
      <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z" />
    </S>
  ),
  Camera: (p: IconProps) => (
    <S {...p}>
      <path d="M4 8.5h3l1.5-2h7L17 8.5h3v10H4z" />
      <circle cx="12" cy="13" r="3.2" />
    </S>
  ),
  Monitor: (p: IconProps) => (
    <S {...p}>
      <rect x="3" y="4" width="18" height="13" rx="2.2" />
      <path d="M9 21h6M12 17v4" />
    </S>
  ),
  Gallery: (p: IconProps) => (
    <S {...p}>
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <circle cx="8" cy="10" r="1.6" />
      <path d="M21 16l-5-4-7 6" />
    </S>
  ),
  Doc: (p: IconProps) => (
    <S {...p}>
      <rect x="5" y="2.5" width="14" height="19" rx="2.5" />
      <path d="M8.5 8h7M8.5 11.5h7M8.5 15h4.5" />
    </S>
  ),
  Refresh: (p: IconProps) => (
    <S {...p}>
      <path d="M20 11.5A8 8 0 1 0 18 17" />
      <path d="M20 5v6h-6" />
    </S>
  ),
  Mail: (p: IconProps) => (
    <S {...p}>
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <path d="M4 7l8 5.5L20 7" />
    </S>
  ),
  Calendar: (p: IconProps) => (
    <S {...p}>
      <rect x="3.5" y="5" width="17" height="15" rx="2.5" />
      <path d="M3.5 9.5h17M8 3v4M16 3v4" />
    </S>
  ),
  Copy: (p: IconProps) => (
    <S {...p}>
      <rect x="9" y="9" width="11" height="11" rx="2.5" />
      <path d="M5 15V5.5A1.5 1.5 0 0 1 6.5 4H15" />
    </S>
  ),
  /** Copier en texte brut : la feuille de dessus porte des lignes de texte, d'où la distinction. */
  CopyPlain: (p: IconProps) => (
    <S {...p}>
      <rect x="9" y="9" width="11" height="11" rx="2.5" />
      <path d="M5 15V5.5A1.5 1.5 0 0 1 6.5 4H15" />
      <path d="M12 13.5h5M12 16.5h3" />
    </S>
  ),
  Logout: (p: IconProps) => (
    <S {...p}>
      <path d="M15 4h3.5A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5H15" />
      <path d="M10 12h10M16 8l4 4-4 4" />
    </S>
  ),
};

export type IconComponent = (props: IconProps) => ReactNode;
